import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import LoadingSpinner from '../ui/LoadingSpinner';

class Login extends Component {

  render() {
    const { isAuthenticated } = this.props.auth;

    if (isAuthenticated()) { 
      return ( <Redirect to='/home' /> );
    } else {
      this.props.auth.login();
    }
  
    return (
      <div>
        <LoadingSpinner/>
      </div>
    );
  }
}

export default Login;